import { useEffect, useState } from 'react';

/**
 * Данный хук может быть полезен для коротких анимаций, когда что-то надо автоматически скрыть через определенное время
 */
export function useBooleanStateAutoResetByTimer(timer = 1000, initValue = false): [boolean, (v: boolean) => void] {
    const [booleanValue, setBooleanValue] = useState(initValue);

    useEffect(() => {
        if (!booleanValue) {
            return;
        }

        const timeoutId = setTimeout(() => {
            setBooleanValue(false);
        }, timer);

        return () => clearTimeout(timeoutId);
    }, [booleanValue, setBooleanValue, timer]);

    return [booleanValue, setBooleanValue];
}
